import React from 'react';
import { Link } from 'react-router-dom';

export default class ServiceSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div
                className="section"
                style={{
                    paddingTop: '60px',
                    paddingBottom: '30px',
                    borderTop: 0,
                    borderBottom: 0,
                    background: '#fff',
                }}
            >
                <div className="container">
                    <div className="row">
                        <div
                            className="col-md-3 service-box service-center animated fadeIn delay-01"
                            data-animation="fadeIn"
                            data-animation-delay="01"
                        >
                            <div className="service-icon">
                                <i className="icon-headphones-2 icon-large-effect icon-effect-1"></i>
                            </div>
                            <div className="service-content">
                                <h4>Réception des appels</h4>
                                <p>
                                    la réception de vos appels entrants, de 8.30
                                    à 19.00 du lundi au vendredi et de 8.30 à
                                    13.00 le samedi.
                                </p>
                                <Link
                                    to="/services"
                                    className="sh-tooltip"
                                    data-placement="left"
                                    data-original-title="Simple Tooltip"
                                >
                                    Plus d'informations
                                </Link>
                            </div>
                        </div>
                        <div
                            className="col-md-3 service-box service-center animated fadeIn delay-02"
                            data-animation="fadeIn"
                            data-animation-delay="02"
                        >
                            <div className="service-icon">
                                <i className=" icon-calendar-4 icon-large-effect icon-effect-1"></i>
                            </div>
                            <div className="service-content">
                                <h4>Prise de rendez-vous</h4>
                                <p>
                                    la prise de rendez-vous, par la mise à
                                    disposition d’un planning web développé par
                                    nos soins ou en interface avec votre RIS
                                </p>
                                <Link
                                    to="/services"
                                    className="sh-tooltip"
                                    data-placement="left"
                                    data-original-title="Simple Tooltip"
                                >
                                    Plus d'informations
                                </Link>
                            </div>
                        </div>
                        <div
                            className="col-md-3 service-box service-center animated fadeIn delay-03"
                            data-animation="fadeIn"
                            data-animation-delay="03"
                        >
                            <div className="service-icon">
                                <i className="icon-mail-1 icon-large-effect icon-effect-1"></i>
                            </div>
                            <div className="service-content">
                                <h4>Convocations et ordonnances</h4>
                                <p>
                                    l’envoi des convocations et ordonnances,
                                    incluant les consignes préparatoires et les
                                    points de vigilance
                                </p>
                                <Link
                                    to="services"
                                    className="sh-tooltip"
                                    data-placement="left"
                                    data-original-title="Simple Tooltip"
                                >
                                    Plus d'informations
                                </Link>
                            </div>
                        </div>
                        <div
                            className="col-md-3 service-box service-center animated fadeIn delay-04"
                            data-animation="fadeIn"
                            data-animation-delay="04"
                        >
                            <div className="service-icon">
                                <i className="icon-clock-1 icon-large-effect icon-effect-1"></i>
                            </div>
                            <div className="service-content">
                                <h4>Confirmation et rappel</h4>
                                <p>
                                    la confirmation des rendez-vous et le rappel
                                    par sms
                                </p>
                                <Link
                                    to="/services"
                                    className="sh-tooltip"
                                    data-placement="left"
                                    data-original-title="Simple Tooltip"
                                >
                                    Plus d'informations
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ServiceSection.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/ServiceSection.jsx